import { render, staticRenderFns } from "./addexercise.vue?vue&type=template&id=01136b7e&scoped=true&"
import script from "./addexercise.vue?vue&type=script&lang=js&"
export * from "./addexercise.vue?vue&type=script&lang=js&"
import style0 from "./addexercise.vue?vue&type=style&index=0&id=01136b7e&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01136b7e",
  null
  
)

export default component.exports